import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/$")({
  component: CatchAllPage,
});

function CatchAllPage() {
  const navigate = useNavigate();
  const { _splat } = Route.useParams();

  useEffect(() => {
    if (_splat !== "index") return;
    supabase.auth.getSession().then(({ data }) => {
      navigate({ to: data.session ? "/dashboard" : "/", replace: true });
    });
  }, [_splat, navigate]);

  if (_splat === "index") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background px-4">
        <div className="max-w-md text-center">
          <h1 className="text-xl font-semibold text-foreground">Laster siden</h1>
          <p className="mt-2 text-sm text-muted-foreground">Sender deg videre til riktig side.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="text-6xl font-semibold text-foreground">404</h1>
        <p className="mt-3 text-sm text-muted-foreground">Siden finnes ikke.</p>
        <Link to="/" className="btn btn-primary mt-6 inline-flex">Til forsiden</Link>
      </div>
    </div>
  );
}